import * as React from 'react';

const BlueLink = (props) => (
 <svg
    xmlns="http://www.w3.org/2000/svg"
    // width={90.611}
    // height={38.9}
    viewBox="0 0 49.903 34.105"
    {...props}
  >
    <g transform="translate(-94.713 -71.753)">
      <circle
        cx={139.623}
        cy={76.747}
        r={4.993}
        style={{
          fill: "#3995e5",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 0.264583,
        }}
      />
      <path
        d="M118.925 76h17.726v1.479h-17.726z"
        style={{
          fill: "#3995e5",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 0.159425,
        }}
      />
      <circle
        cx={-99.706}
        cy={100.865}
        r={4.993}
        style={{
          fill: "#3995e5",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 0.264583,
        }}
        transform="scale(-1 1)"
      />
      <path
        d="M-120.404 100.118h17.726v1.479h-17.726z"
        style={{
          fill: "#3995e5",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 0.159425,
        }}
        transform="scale(-1 1)"
      />
      <path
        d="M76.006-120.407h25.593v1.479H76.006z"
        style={{
          fill: "#3995e5",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 0.191566,
        }}
        transform="rotate(90)"
      />
    </g>
  </svg>
);

export default BlueLink;
